import React from 'react';

const PlanSkeleton = () => (
  <div style={{
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '24px',
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      gap: '24px',
      height: '250px',
      width: '100%',
      boxSizing: 'border-box',
      marginBottom: '24px'
  }}>
      <div style={{ flex: '0 0 200px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ width: '100%', height: '60px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
          <div style={{ width: '80%', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
          <div style={{ width: '60%', height: '16px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
      </div>
      <div style={{ flex: 1, display: 'flex', gap: '24px' }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ width: '100%', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
              <div style={{ width: '100%', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
              <div style={{ width: '100%', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
          </div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ width: '100%', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
              <div style={{ width: '100%', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
              <div style={{ width: '100%', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
          </div>
      </div>
      <div style={{ flex: '0 0 250px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '16px' }}>
          <div style={{ width: '120px', height: '30px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
          <div style={{ width: '180px', height: '24px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
          <div style={{ width: '100%', height: '48px', backgroundColor: '#f0f0f0', borderRadius: '4px', marginTop: 'auto' }} />
          <div style={{ width: '100%', height: '48px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
      </div>
  </div>
);

export default PlanSkeleton;



// WEBPACK FOOTER //
// ./src/views/v2/search/components/plansTable/skeleton.jsx